import type { getNodeViewportPosition } from '../../../modules/dom.utils';
import type { FieldElementType } from '../../../types/dom-types';
import type { ReferenceObject } from '../../../types/Schema';
import type { FieldDefinitionAttributes } from '../../processors/OutlineProcessor/FieldDefinition';
import type FieldDefinition from '../../processors/OutlineProcessor/FieldDefinition';

export type OutlineNodeOffset = ReturnType<typeof getNodeViewportPosition>;

export enum OutlineType {
    Default = 'default',
    Selected = 'selected',
    Simple = 'simple',
    SimpleParent = 'simple-parent'
}

export enum OutlineButtonType {
    None = 'none',
    Edit = 'edit',
    Navigate = 'navigate',
    ObjectAddBefore = 'object_add_before',
    ObjectAddAfter = 'object_add_after',
    ObjectRemove = 'object_remove',
    ImageRemove = 'image_remove',
    ImageUseExisting = 'image_use_existing',
    ImageUpload = 'image_upload',
    MoveBefore = 'move_before',
    MoveAfter = 'move_after',
    Code = 'code',
    Content = 'content',
    Style = 'style',
    SavePreset = 'save_preset',
    Action = 'action'
}

export type OutlineParent = {
    fieldDefinition: FieldDefinition;
    xpath: string;
    referencedObjects?: ReferenceObject[];
    hasReferencedObjects?: boolean;
    totalReferences?: number;
};

export type Outline = {
    type: OutlineType;
    isActive: boolean;
    isHover: boolean;
    title?: string;
    fieldDefinition: FieldDefinition;
    parents: OutlineParent[];
    hasReferencedObjects?: boolean;
    totalReferences?: number;
    referencedObjects?: ReferenceObject[];
    linkedFieldDefinition?: FieldDefinition;
    xpath: string;
    elementType: FieldElementType;
    attributes?: FieldDefinitionAttributes;
    buttonsState: { [K in OutlineButtonType]?: boolean };
    isStylePanelVisible: boolean;
};
